import { FC, useState } from 'react';
import { Button } from '@mui/material';
import { subscribeToNews } from '../../api/http-client/queries/newsletters';
import { emailRegex, notifyMessages } from '../../utilities/constants';
import { useTranslates } from '../../providers/translates';
import { setOpen } from 'store/reducers/notifySlice';
import { isVac } from "utilities/is-vac";
import LineBlock from '../LineBlock';
import { Language } from 'providers/translates/enums';
import { vacFooterLabel } from 'utilities/vac-copy';
import Footer from '../Footer';
import { useAppDispatch } from 'hooks';

import './footer.scss';
import { Partners } from 'components/Partners';

const FullFooter: FC = () => {
  const { translates: t, selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;
  const dispatch = useAppDispatch();

  const [email, setEmail] = useState('');

  return (
    <>
      <section style={{ backgroundColor: '#fff' }}>
        <Partners isHomePage />
        <LineBlock />
        <div className="landing-footer">
          <div className="center">
            <div className={`${'contact'}${isVac() ? ` contactisVac` : ``}`}>
              {!isVac() && (
                  <div className="footer-col">
                  <div className="title">{t?.footer?.subscribe || 'Subscribe'}</div>
                  <div className="desc">
                    {t?.footer?.subscribeText ||
                      `Our free monthly newsletter offers the latest news, tools, and resources for
                  palliative care, advanced illness, and grief.`}
                  </div>
                  <Button
                      sx={{ lineHeight: 'initial', p: '12px 25px !important' }}
                      className="signup colored-btn featured-btn"
                      href="https://nut.sh/ell/forms/367648/Dy8fr6"
                      target="__blank"
                    >
                      {t?.footer?.signUp || 'Subscribe'}
                      <i className="fa fa-chevron-right"></i>
                  </Button>
                </div>
                )}
              <div className="footer-col">
                <div className="title">{t?.footer?.donate || 'Donate'}</div>
                <div className="desc">
                  {t?.footer?.donateText ||
                    `Please help us continue our work. Support our registered charity, the International
                Centre for Dignity and Palliative Care, Inc.`}
                </div>
                <Button
                  sx={{ lineHeight: 'initial', p: '12px 25px !important' }}
                  className="donate colored-btn featured-btn"
                  href={isFrench ? "https://www.canadahelps.org/fr/charities/the-international-centre-for-dignity-and-palliative-care-inc/" : "https://www.canadahelps.org/en/charities/the-international-centre-for-dignity-and-palliative-care-inc/"}
                  target="__blank"
                >
                  {vacFooterLabel(selectedLang, t?.footer?.donateToday, 'donateToday', 'Donate today')}
                  <i className="fa fa-chevron-right"></i>
                </Button>
              </div>
              <div className="footer-col">
                <div className="title">{t?.footer?.follow || 'Follow'}</div>
                <div className="desc">
                  {t?.footer?.followText ||
                    `Socialize with #VirtualHospice for more news, stories and resources from us and our
                partners across Canada and around the world.`}
                </div>
                <div className="icon-links">
                  <a
                    className="link-item"
                    href="https://www.facebook.com/pages/Canadian-Virtual-Hospice/119170451459541?ref=ts"
                    target="__blank"
                  >
                    <i className="fa fa-facebook-f"></i>
                  </a>
                  <a
                    className="link-item"
                    href="https://twitter.com/VirtualHospice"
                    target="__blank"
                  >
                    <i className="fa fa-twitter"></i>
                  </a>
                  <a
                    className="link-item"
                    href="https://www.instagram.com/canadianvirtualhospice/"
                    target="__blank"
                  >
                    <i className="fa fa-instagram"></i>
                  </a>
                  <a
                    className="link-item"
                    href="https://www.youtube.com/user/cvhcvcsp?ob=video-mustangbase"
                    target="__blank"
                  >
                    <i className="fa fa-youtube"></i>
                  </a>
                  <a
                    className="link-item"
                    href="https://www.linkedin.com/company/canadian-virtual-hospice"
                    target="__blank"
                  >
                    <i className="fa fa-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default FullFooter;
